module.exports = __webpack_public_path__ + "img/Sibiu_2_kl.9f955b90.jpg";